/**
 * Enumeration types for action
 */
export enum ActionType {
    BASE,
    TRIGGER,
    TOGGLE,
  }
  